import * as React from 'react';
import {alpha} from "@mui/material/styles";
import { VARIANTS } from "@ui-seeker/core"

import { COLORS, THEME_MODE, COLOR_TONES } from "../../../@constants";
import {CloseIcon} from "./@CustomIcons";

const overrideChipStyles = theme => {
    const isLight = theme.palette.mode === THEME_MODE.LIGHT;

    const rootStyle = (ownerState) => {
        const defaultColor = ownerState.color === 'default';

        const filledVariant = ownerState.variant === VARIANTS.FILLED
        const outlinedVariant = ownerState.variant === VARIANTS.OUTLINED
        const softVariant = ownerState.variant === VARIANTS.SOFT;

        const defaultStyle = {
            height: "unset",

            ">span": {
                whiteSpace: "pre-wrap",
                padding: "0 0.5rem"
            },

            ...(defaultColor && {
                '& .MuiChip-avatar': {
                    color: theme.palette.text[isLight ? COLORS.SECONDARY : COLORS.PRIMARY],
                    backgroundColor: alpha(theme.palette.grey[500], 0.48)
                },
                // OUTLINED
                ...(outlinedVariant && {
                    border: `solid 1px ${alpha(theme.palette.grey[500], 0.32)}`
                }),
                // SOFT
                ...(softVariant && {
                    color: theme.palette.text.primary,
                    backgroundColor: alpha(theme.palette.grey[500], 0.16),
                    '&:hover': {
                        backgroundColor: alpha(theme.palette.grey[500], 0.32)
                    }
                })
            })
        };

        const colorStyle = Object.values(COLORS).map((color) => ({
            ...(ownerState.color === color && {
                '& .MuiChip-avatar': {
                    color: theme.palette[color].lighter,
                    backgroundColor: theme.palette[color].dark
                },
                // FILLED
                ...(filledVariant && {
                    '& .MuiChip-deleteIcon': {
                        color: alpha(theme.palette[color].contrastText, 0.56),
                        '&:hover': {
                            color: theme.palette[color].contrastText
                        }
                    }
                }),
                // SOFT
                ...(softVariant && {
                    color: theme.palette[color][isLight ? COLOR_TONES.DARK : COLOR_TONES.LIGHT],
                    backgroundColor: alpha(theme.palette[color].main, 0.16),
                    '&:hover': {
                        backgroundColor: alpha(theme.palette[color].main, 0.32)
                    },
                    '& .MuiChip-deleteIcon': {
                        color: alpha(theme.palette[color][isLight ? COLOR_TONES.DARK : COLOR_TONES.LIGHT], 0.48),
                        '&:hover': {
                            color: theme.palette[color].dark
                        }
                    }
                })
            })
        }));

        return [...colorStyle, defaultStyle];
    };

    return {
        MuiChip: {
            defaultProps: {
                deleteIcon: <CloseIcon />,
                color: 'primary',
            },

            styleOverrides: {
                root: ({ ownerState }) => rootStyle(ownerState),
            },
        },
    }
}

export default overrideChipStyles